/** Helpers puros de layout partilhados pelos blocos (testados em `agencia.helpers.unit.test.ts`). */

export type FundoCartao = 'cinza' | 'preto' | 'primario' | 'branco'

/**
 * Fundo do cartão `index` num ciclo configurável (ex.: cinza → preto → cinza → primário).
 * Lista vazia ou inválida cai no ciclo padrão da referência.
 */
export function fundoDoCiclo(index: number, ciclo: readonly (FundoCartao | string | null | undefined)[] | null | undefined): FundoCartao {
  const valido: FundoCartao[] = (ciclo ?? []).filter(
    (c): c is FundoCartao => c === 'cinza' || c === 'preto' || c === 'primario' || c === 'branco',
  )
  const base: FundoCartao[] = valido.length ? valido : ['cinza', 'preto', 'cinza', 'primario']
  return base[((index % base.length) + base.length) % base.length]
}

/** Índice seguinte/anterior numa lista circular. */
export function indiceCircular(atual: number, total: number, passo: 1 | -1): number {
  if (total <= 0) return 0
  return (((atual + passo) % total) + total) % total
}

/** Agrupa a galeria em linhas: imagens «total» ocupam a linha; «metade» vão aos pares. */
export function linhasGaleria<T extends { largura?: string | null }>(itens: T[]): T[][] {
  const linhas: T[][] = []
  let par: T[] = []
  for (const it of itens) {
    if (it.largura === 'metade') {
      par.push(it)
      if (par.length === 2) {
        linhas.push(par)
        par = []
      }
    } else {
      if (par.length) {
        linhas.push(par)
        par = []
      }
      linhas.push([it])
    }
  }
  if (par.length) linhas.push(par)
  return linhas
}
